import { motion } from "motion/react";
import { Check } from "lucide-react";
import { Stagger } from "../components/Reveal";
import { EASE } from "../motion";

const items = [
  "100% Satisfaction Guarantee",
  "Premium Skin-Safe Products Only",
  "Uncompromising Hygiene Standards",
  "Established in Manly Since 2009",
];

const cell = { hidden: { opacity: 0, x: -16 }, show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: EASE } } };
const tick = {
  hidden: { scale: 0, rotate: -45 },
  show: { scale: 1, rotate: 0, transition: { type: "spring", stiffness: 500, damping: 18, delay: 0.15 } },
};

export default function TrustStrip() {
  return (
    <section className="trust section--red">
      <Stagger className="container trust__grid" gap={0.1} amount={0.5}>
        {items.map((t) => (
          <motion.div key={t} className="trust__cell" variants={cell}>
            <motion.span variants={tick} className="trust__tick"><Check aria-hidden="true" /></motion.span>
            <span>{t}</span>
          </motion.div>
        ))}
      </Stagger>
    </section>
  );
}
